import React, { useState, useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import API_DOMAIN from "../config/config";
import logo from "../assests/images/logo.png";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "white",
    padding: 25,
  },
  section: {
    flexDirection: "column",
    flexGrow: 1,
    position:'absolute',
    display: "flex",
    marginLeft: 30,
    marginTop: 20,
    width:'100%',
  },
  text2: {
    fontSize: 14,
    fontFamily: "Times-Roman",
    color: "#000",
    marginLeft: '63%',
    marginTop:'-20px', 
  },
  text3: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    color: "#000",
    marginVertical:'40px',
  },
  text4: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    color: "#000",
    marginTop:'40px',
    marginBottom:'40px',
  },
  text: {
    fontSize: 13,
    fontFamily: "Times-Roman",
    textAlign: "center",

    color: "#000",
    width: "100%",
  },
  // invoice-title start
  headertext: {
    fontSize: 10,
    fontFamily: "Times-Roman",

    color: "#000",
    width: "100%",
    padding: 6,
  },
  head: {
    fontSize: 10,
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
  },
  estimatehead: {
    paddingHorizontal: 8,
  },
  invoice: {
    fontWeight: "bolder",
    fontSize: 12,
    textAlign: "center",
    flexDirection: "row",
    width: "100%",
  },

  // invoice-title start
  bold: {
    fontWeight: "900",
    fontSize: 10,
  },
  // table start
  table: {
    display: "flex",
    padding: 6,
    justifyContent: "flex-end",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  tableCell: {
    flex: 4,
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  // table end
  companyview: {
    display: "flex",
    flexDirection: "row",
  },
  padtp: {
    paddingTop: 5,
  },
  padbot: {
    paddingBottom: 5,
  },
  comapany: {
    paddingRight: 8.6,
  },
  address1: {
    paddingRight: 33,
  },
  mobile: {
    paddingRight: 27,
  },
  colon: {
    paddingRight: 7,
  },
  comval: {
    fontSize: 10,
  },
  estino: {
    paddingRight: 3,
    paddingLeft: 3,
  },
  estidate: {
    paddingLeft: 3,
    paddingRight: 30,
  },
  producthead: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    border: 1,
    borderColor: "#000",
  },

  headerRow: {
    flexDirection: "row",
    border: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderColor: "#000",
  },

  bodydescription: {
    minHeight: 500,
  },

  productbody: {
    flexDirection: "row",
    borderBottom: 1,
  },

  // Common cell style
  cell: {
    padding: 3,
    fontSize: 9,
    fontFamily: "Times-Roman",
  },

  // Column widths
  no: {
    width: "6%",
    textAlign: "center",
    borderRight: 1,
  },
  no1: {
    width: "6%",
    textAlign: "center",
    borderRight: 1,
  },
  code: {
    width: "8%",
    textAlign: "center",
    borderRight: 1,
  },
  code1: {
    width: "8%",
    textAlign: "center",
    borderRight: 1,
  },
  cracker: {
    width: "37%",
    textAlign: "left",
    paddingLeft: 3,
    borderRight: 1,
  },
  cracker1: {
    width: "37%",
    textAlign: "left",
    paddingLeft: 3,
    borderRight: 1,
  },
  rateper: {
    width: "11%",
    textAlign: "center",
    borderRight: 1,
  },
  rateper1: {
    width: "11%",
    textAlign: "center",
    borderRight: 1,
  },
  qty: {
    width: "10%",
    textAlign: "center",
    borderRight: 1,
  },
  qty1: {
    width: "10%",
    textAlign: "center",
    borderRight: 1,
  },


  groupHeader: {
    width: "16%",              // adjust as needed
    flexDirection: "column",
    alignItems: "center",
    borderRight: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,

  },
  groupHeader1: {
    width: "16%",              // adjust as needed
    flexDirection: "column",
    alignItems: "center",
    borderRight: 0,
  },

  groupTitle: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 2,
    textAlign: "center",
  },

  subHeaderRow: {
    flexDirection: "row",
    width: "100%",
    borderTop: 1,

  },
  subHeaderRow1: {
    flexDirection: "row",
    width: "100%",
    borderTop: 0,

  },

  subHeaderCell: {
    flex: 1,
    fontSize: 9,
    textAlign: "center",
    borderRight: 1,
    borderBottomWidth: 0,
   
  },
  subHeaderCell1: {
    flex: 1,
    fontSize: 9,
    textAlign: "center",
    borderRight: 0,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderLeft: 0,
    borderBottomWidth: 0,
  },

  valueCell: {
    flex: 1,
    fontSize: 9,
    textAlign: "center",
    padding:3,
  },
  rate: {
    flex: 1,
    textAlign: "right",
    paddingRight: 3,
  },
  amount: {
    flex: 1,
    textAlign: "right",
    paddingRight: 3,
  },

  boxdetails: {
    display: "flex",
    flexDirection: "row",
    border: 1,
    borderColor: "#000",
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    borderRightWidth: 0,
  },

  w70: {
    width: "65%",
    borderRight: 1,
  },

  w40: {
    width: "35%",
  },

  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  label: {
    fontSize: 9,
    fontFamily: "Times-Roman",
  },

  value: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "right",
  },
  priceCell: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    padding:3,
  },
  // signs end

  firstboxdetails: {
    display: "flex",
    flexDirection: "row",
    border: 1,
    borderColor: "#000",
    borderBottomWidth: 0,
    justifyContent: "space-between", // Even spacing
    alignItems: "center", // Vertical alignment
    padding: 5,
  },
  secondboxdetails: {
    display: "flex",
    flexDirection: "row",
    border: 1,
    borderColor: "#000",
    borderBottomWidth: 0,
    justifyContent: "space-between", // Even spacing
    alignItems: "center", // Vertical alignment
  },
  logo1: {
    width: "25%",
  },

  logo: {
    width: 100,
    height: 80,
  },

  address: {
    width: "45%",
    paddingHorizontal: 5,
  },

  contact: {
    width: "35%",
    textAlign: "left", // align right side text
  },

  text: {
    fontSize: 10,
    marginBottom: 2,
  },

  box: {
    fontSize: 9,
    width: "50%",
    padding: 5,
  },
  firstbox: {
    fontSize: 9,
    width: "69.2%",
    paddingLeft: 7,
  },
  secondbox: {
    fontSize: 8,
    width: "30.8%",
    paddingVertical: 5,
    alignSelf: "flex-start",
  },
  brdright: { borderRight: 1, color: "#000" },
  print: {
    fontSize: 9,
    textAlign: "right",
  },

  watermark: {
    position: "absolute",
    top: "35%",
    left: "24%",
    right: "0%",
    width: "70%",
    height: "40%",
    opacity: 0.1,
    margin: "0 auto",
    display: "flex",
  },
//footer//
footer: {
    fontSize: 9,
    display: "flex",
    justifyContent: "flex-end",
  },
  footerRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  footerleft: {
    height: 62,
    borderBottom: 0.5,
  },
  footerCell: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    width: "100%",
  },
  footerBottom: {
    position: "absolute",
    bottom: 15, // fix it at bottom of page
    left: 26,
    right: 26,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  footerLeft: {
    fontSize: 8,
    fontFamily: "Times-Roman",
    textAlign: "left",
    flex: 1,
    marginVertical:'60px',
    marginLeft:'7px',
  },

  footerCenter: {
    fontSize: 8,
    fontFamily: "Times-Roman",
    textAlign: "center",
    flex: 2,
    marginVertical:'60px',
  },

  footerRight: {
    fontSize: 8,
    fontFamily: "Times-Roman",
    textAlign: "right",
    flex: 3,
    marginVertical:'60px',
  },


});

const EstimationPdf = ({ data }) => {
  
console.log("data", data);
   // Function to convert rupees to words
  function convertRupeesToWordsWithBreaks(amount) {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const thousands = ["", "Thousand", "Lakh", "Crore"];

    function convertGroup(number, thousandIndex) {
      if (number === 0) return "";

      let str = "000" + number;
      str = str.slice(-3);

      const hundred = parseInt(str[0], 10);
      const ten = parseInt(str[1], 10);
      const one = parseInt(str[2], 10);

      let words = [];

      if (hundred > 0) {
        words.push(ones[hundred] + " Hundred");
      }

      if (ten === 1) {
        words.push(teens[one]);
      } else {
        if (ten > 0) {
          words.push(tens[ten]);
        }
        if (one > 0) {
          words.push(ones[one]);
        }
      }

      if (thousandIndex > 0 && words.length > 0) {
        words.push(thousands[thousandIndex]);
      }

      return words.join(" ");
    }

    function convertIntegerPart(integerPart) {
      const groups = [];
      let thousandIndex = 0;

      while (integerPart > 0) {
        groups.push(
          convertGroup(
            integerPart % (thousandIndex === 1 ? 100 : 1000),
            thousandIndex
          )
        );
        integerPart = Math.floor(
          integerPart / (thousandIndex === 1 ? 100 : 1000)
        );
        thousandIndex++;
      }

      const resultGroups = groups.reverse().filter((group) => group !== "");
      const lastGroupIndex = resultGroups.length - 1;
      const formattedGroups = resultGroups.map((group, index) =>
        index === lastGroupIndex ? group : group
      );

      return formattedGroups.join(" ");
    }

    function convertDecimalPart(decimalPart) {
      if (decimalPart === 0) {
        return "";
      }

      let paise = Math.round(decimalPart * 100);
      return convertGroup(paise, 0) + " Paise";
    }

    const integerPart = Math.floor(amount);
    const decimalPart = amount - integerPart;

    const integerWords = convertIntegerPart(integerPart);
    const decimalWords = convertDecimalPart(decimalPart);

    const result =
      integerWords + " Rupees" + (decimalWords ? "\nAnd " + decimalWords : "");
    return result.trim();
  }
// Function to convert rupees to words


  const [userdata, setUserData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/company.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  function chunkArray(array, chunkSize) {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}

// Helper: split value into Rs and Ps
const formatRsPs = (value) => {
  const num = Number(value || 0);
  const rupees = Math.floor(num);
  const paise = Math.round((num - rupees) * 100);
  return {
    rs: rupees.toString(),
    ps: paise.toString().padStart(2, "0"), // ensures 2 digits (e.g. "05")
  };
};

// Function to format date from yyyy-mm-dd to dd-mm-yyyy
  function formatDate(dateStr) {
    if (!dateStr) return " ";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  }

  // Calculate GST amounts
  const totalGST = Number(data.gst_amount || 0).toFixed(2);
  const isIGST = (data.gst_type || "").toLowerCase().includes("igst");
  const sgstAmount = isIGST ? "0.00" : (Number(totalGST) / 2).toFixed(2);
  const cgstAmount = isIGST ? "0.00" : (Number(totalGST) / 2).toFixed(2);

  const words = convertRupeesToWordsWithBreaks(data.total);

  return (
    <Document>
      {chunkArray(data.product, 30).map((productChunk, pageIndex) => (
      <Page size="A4" style={styles.page}>
      
      
        <Image style={styles.watermark} src={logo} />
       <View style={{ flexDirection: "row" }}>
          <Text style={styles.text2}>Estimation</Text>
        </View>
        <View style={styles.section}>
          <View style={styles.firstboxdetails}>
            <View style={styles.logo1}>
              <Image style={styles.logo} src={logo} />
            </View>

            <View style={styles.address}>

              <Text style={styles.text}><Text style={styles.bold}>Address:</Text> No. 1/180B, S. No. 401/29,</Text>
              <Text style={styles.text}>Valayankulam, Arasapatti Bus Stop,</Text>
              <Text style={styles.text}>Watrap, Tamil Nadu 62614</Text>
              <Text style={styles.text}>{"     "}</Text>
              <Text style={styles.text}><Text style={styles.bold}>Domain:</Text> www.kalaicrackers.in</Text>
            </View>


            <View style={styles.contact}>
              <Text style={styles.text}><Text style={styles.bold}>Email:</Text> kalaicrackers@gmail.com</Text>
              <Text style={styles.text}>{"     "}</Text>
              <Text style={styles.text}><Text style={styles.bold}>Mobile Number:</Text> +91 98949 06923</Text>
              <Text style={styles.text}>{""}</Text>
              <Text style={styles.text}>{""}</Text>
            </View>
          </View>

          <View style={[styles.secondboxdetails]}>
            <View style={[styles.brdright, styles.firstbox]}>
              <View style={[styles.companyview, styles.padtp, styles.padbot]}>
                <Text style={[styles.comapany, styles.comval, styles.bold]}>
                  To {"                 "}
                </Text>
                <Text style={[styles.colon, styles.comval]}>:</Text>
                <Text style={[styles.comval, styles.bold]}>
                  {data.party_name}
                </Text>
              </View>
              <View style={[styles.companyview, styles.padbot]}>
                <Text style={[styles.address1, styles.comval, styles.bold]}>Address</Text>
                <Text style={[styles.colon, styles.comval]}>:</Text>
                <Text style={[styles.comval, styles.bold]}>
                  {data.address}
                </Text>
              </View>
              {/* <Text>{data.company_details.gst_no}</Text> */}
              <View style={[styles.companyview, styles.padbot]}>
                <Text style={[styles.mobile, styles.comval, styles.bold]}>Contact {" "} </Text>
                <Text style={[styles.colon, styles.comval]}>:</Text>
                <Text style={[styles.comval, styles.bold]}>
                  {data.mobile_number}
                </Text>
              </View>
            </View>
            <View style={styles.secondbox}>
              <View style={[styles.companyview, styles.padbot]}>
                <Text style={[styles.estino, styles.bold]}>Estimate.No</Text>
                <Text style={[styles.colon]}>:</Text>
                <Text style={[styles.comval]}>{data.bill_no}</Text>
              </View>
              <View style={[styles.companyview]}>
                <Text style={[styles.estidate, styles.bold]}>Date{"  "}</Text>
                <Text style={[styles.colon]}>:</Text>
                <Text style={[styles.comval]}>{formatDate(data.bill_date)}</Text>
              </View>

              {/* <Text>{data.mobile_number}</Text>
              <Text>{}</Text> */}
            </View>
          </View>

          <View style={styles.producthead}>
            {/* Header Row 1 */}
            <View style={styles.headerRow}>
              <Text style={[styles.no, styles.cell]}>SNo</Text>
              <Text style={[styles.code, styles.cell]}>Code</Text>
              <Text style={[styles.cracker, styles.cell]}>Cracker name</Text>
              <Text style={[styles.rateper, styles.cell]}>Rate Per</Text>
              <Text style={[styles.qty, styles.cell]}>Quantity</Text>

              {/* Rate Group */}
              <View style={styles.groupHeader}>
                <Text style={styles.groupTitle}>Rate</Text>
                <View style={styles.subHeaderRow}>
                  <Text style={styles.subHeaderCell}>Rs</Text>
                  <Text style={styles.subHeaderCell1}>Ps</Text>
                </View>
              </View>

              {/* Total Group */}
              <View style={styles.groupHeader1}>
                <Text style={styles.groupTitle}>Total</Text>
                <View style={styles.subHeaderRow}>
                  <Text style={[styles.subHeaderCell]}>Rs</Text>
                  <Text style={styles.subHeaderCell1}>Ps</Text>
                </View>
              </View>
            </View>


            {/* BODY */}
            <View style={styles.bodydescription}>
               {productChunk.map((product, index) => (
              <View style={styles.productbody} key={index}>
                <Text style={[styles.no1, styles.cell]}>{pageIndex * 29 + index + 1}</Text>
                <Text style={[styles.code1, styles.cell]}>{product.product_code}</Text>
                <Text style={[styles.cracker1, styles.cell]}>{product.product_name}</Text>
                <Text style={[styles.rateper1, styles.cell]}>{product.unit_name}</Text>
                <Text style={[styles.qty1, styles.cell]}>{product.qty}</Text>

                {/* Rate Values */}
                <View style={styles.groupHeader}>
                  <View style={styles.subHeaderRow1}>
                    <Text style={[styles.valueCell,styles.brdright]}>{formatRsPs(product.price_unit).rs}</Text>
                    <Text style={styles.valueCell}>{formatRsPs(product.price_unit).ps}</Text>
                  </View>
                </View>

                {/* Total Values */}
                <View style={styles.groupHeader1}>
                  <View style={styles.subHeaderRow1}>
                    <Text style={[styles.valueCell,styles.brdright]}> {formatRsPs(product.without_tax_amount).rs}</Text>
                    <Text style={styles.valueCell}>{formatRsPs(product.without_tax_amount).ps}</Text>
                  </View>
                </View>  
              </View>
              ))}
            </View>


            <View style={styles.boxdetails}>
              {/* Left Side - Amount in Words */}
              <View style={[styles.box, styles.w70]}>
                <Text style={styles.priceCell}>Amount in words :</Text>
                <Text style={styles.priceCell}>{words} Only</Text>
              </View>

              {/* Right Side - Totals Section */}
              <View style={[styles.box, styles.w40]}>
                <View style={styles.row}>
                  <Text style={styles.label}>Discount Items</Text>
                  <Text style={styles.value}>{data.sub_total}</Text>
                </View>
                <View style={styles.row}>
                  {data.discount_type === "Discount Amount" ? (
                    <Text style={styles.label}>Discount Amount</Text>
                  ) : (
                    <Text style={styles.label}>Discount {data.discount}%</Text>
                  )}

                  <Text style={styles.value}>{data.discount_amount}</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.label}>Total</Text>
                  <Text style={styles.value}>
                    {data.sub_total - data.discount_amount}
                  </Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.label}>
                    Packing {data.packing_percentage}%
                  </Text>
                  <Text style={styles.value}>{data.packing_amount}</Text>
                </View>

                <View style={styles.row}>
                  <Text style={styles.label}>Grand Total</Text>
                  <Text style={styles.value}>{data.total}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
       
        <View style={styles.footerBottom}>
                  <Text style={styles.footerLeft}>E & O.E</Text>
                  <Text style={styles.footerCenter}>
                    
                  </Text>
                  <Text style={styles.footerRight}>
                    Thank you for business with us!
                  </Text>
                  </View>
                  
      </Page>
      ))}
    </Document>
  );
};

export default EstimationPdf;
